/* eslint-disable import/no-anonymous-default-export */
// VERSION 1.0.0
// AUTHOR AGALYA
// LastEdit : SATHISH
// LastAdd : CODE REVIEW CORRECTION AND PAGE WISE CHECK
// MODFIED DATE:06-11-2025

import { docodeHexResponse } from '../../_common/common.utils';
import RuleEngineActionTypes from './rule-engine.types';

const INITIAL_STATE = {
	// GET RULE ENGINE LIST RESPONSE
	getRuleEngineListStatus: null,
	getRuleEngineListArr: [],

	// ADD RULE ENGINE LIST RESPONSE
	addRuleEngineListStatus: null,
	addRuleEngineListArr: [],

	// DELETE RULE ENGINE LIST RESPONSE
	deleteRuleEngineListStatus: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET RULE ENGINE LIST START *********************** */
		case RuleEngineActionTypes.GET_RULE_ENGINE_LIST_SUCCESS:
			return {
				...state,
				getRuleEngineListStatus: action.payload,
				getRuleEngineListArr: docodeHexResponse(action.payload, 'getRuledetailsKey'),
			};

		case RuleEngineActionTypes.GET_RULE_ENGINE_LIST_FAILURE:
			return {
				...state,
				getRuleEngineListStatus: action.payload,
				getRuleEngineListArr: null,
			};

		case RuleEngineActionTypes.GET_RULE_ENGINE_LIST_CHANGED:
			return { ...state, getRuleEngineListStatus: null };
		/** ***************** GET RULE ENGINE LIST END *********************** */

		/** ***************** ADD RULE ENGINE LIST START *********************** */
		case RuleEngineActionTypes.ADD_RULE_ENGINE_LIST_SUCCESS:
			return {
				...state,
				addRuleEngineListStatus: action.payload,
			};

		case RuleEngineActionTypes.ADD_RULE_ENGINE_LIST_FAILURE:
			return { ...state, addRuleEngineListStatus: action.payload };

		case RuleEngineActionTypes.ADD_RULE_ENGINE_LIST_CHANGED:
			return { ...state, addRuleEngineListStatus: null };
		/** ***************** ADD RULE ENGINE LIST END *********************** */

		/** ***************** DELETE RULE ENGINE LIST START *********************** */
		case RuleEngineActionTypes.DELETE_RULE_ENGINE_LIST_SUCCESS:
			return {
				...state,
				deleteRuleEngineListStatus: action.payload,
			};

		case RuleEngineActionTypes.DELETE_RULE_ENGINE_LIST_FAILURE:
			return { ...state, deleteRuleEngineListStatus: action.payload };

		case RuleEngineActionTypes.DELETE_RULE_ENGINE_LIST_CHANGED:
			return { ...state, deleteRuleEngineListStatus: null };
		/** ***************** DELETE RULE ENGINE LIST END *********************** */
		default:
			return state;
	}
};
